import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { HtmlViewDialogComponent } from './html-view-dialog.component';
import { DirectivesModule } from '../../common';

@NgModule({
  imports: [CommonModule, MatDialogModule, DirectivesModule, MatButtonModule, TranslateModule.forChild({})],
  declarations: [HtmlViewDialogComponent],
  exports: [HtmlViewDialogComponent],
})
export class HtmlViewDialogModule {}
